import arrayUtils from '@/utils/arrayUtils';

import {getBannersConfig, getConfig, getLoyaltyConfig, getMediaConfig, getPagesConfig} from './config';

const getDeviceSupport = () => getConfig().deviceSupport || [];
const getDeviceSettings = (deviceType) => {
    const deviceSettings = getConfig().deviceSettingsList;

    if (!deviceSettings?.length) return [];

    return deviceSettings.find((x) => x?.deviceType?.deviceType === deviceType)?.deviceSettings || [];
};

const getHomePageForYouSection = () => getBannersConfig().forYouSection || [];
const getHomePageAutoDeliveryBanner = () => getBannersConfig().homePageAutoDeliveryBanner;
const getWarningBanners = () => getBannersConfig().warningBanners || [];
const getTopBanners = () => getBannersConfig().topBanners;
const getAutoDeliveryDetailedBannerNone = () => getBannersConfig().autoDeliveryDetailedBannerNone;
const getAutoDeliveryDetailedBannerInactive = () => getBannersConfig().autoDeliveryDetailedBannerInactive;
const getHighlights = () => getBannersConfig().highlights;
const getHighlightsDesktop = () => getBannersConfig().highlightsDesktop;
const getHighlightsAutoplay = () => getBannersConfig().highlightsAutoplay;
const getHighlightsDesktopAutoplay = () => getBannersConfig().highlightsDesktopAutoplay;
const getYourUsualBanners = () => getBannersConfig().yourUsualBanners;
const getShopByProductSection = () => getBannersConfig().shopByProductSection;
const getClubPlusSection = () => getBannersConfig().clubPlusSection;
const getQuickOrderBanner = () => getBannersConfig().quickOrderBanner;

const getIsLoyaltyEnabled = () => getLoyaltyConfig().isLoyaltyEnabled;
const getIsDcxLoyaltyEnabled = () => getLoyaltyConfig().isDcxLoyaltyEnabled;
const getIsLoyaltyApiEnabled = () => getLoyaltyConfig().isLoyaltyApiEnabled;
const getIsLoyaltyProgressBarEnabled = () => getLoyaltyConfig().isLoyaltyProgressBarEnabled;
const getLoyaltyLevels = () => getLoyaltyConfig().loyaltyLevels;
const getIsLoyaltyButtonsBarEnabled = () => getLoyaltyConfig().isLoyaltyButtonsBarEnabled;
const getLoyaltyButtonsBar = () => getLoyaltyConfig().loyaltyButtonsBar;

const getLoyaltyBadgeSsoUrl = () => getConfig().loyaltySettings?.badgeSsoUrl;
const getLoyaltyFinishWhatYouStartedSsoUrl = () => getConfig().loyaltySettings?.finishWhatYouStartedSsoUrl;

const getIsRestrictedMarket = () => false;
const getIsWarningIconEnabled = () => true;

const getAdConfig = (deviceType, step) => {
    const adConfigs = getConfig().adConfigs;
    const adConfig = adConfigs?.find((x) => x.device.deviceType === deviceType);

    if (!adConfig) return [];

    if (!step) return adConfig;

    return adConfig[step] || [];
};

const getContactUs = () => getConfig().contactUs;
const getEnableNotificationPageHeaderImageMedia = () => getMediaConfig().enableNotificationPageHeaderImageMedia;
const getEnableNotificationPageHeaderVideoSrc = () => getMediaConfig().enableNotificationPageHeaderVideoSrc;
const getEnableNotificationPageHeaderVideoThumbnailSrc = () =>
    getMediaConfig().enableNotificationPageHeaderVideoThumbnailSrc;
const getEnableNotificationPageIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().enableNotificationPageIcons);

const getAutoDeliveryDashboardInactiveBenefitsIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().autoDeliveryDashboardInactiveBenefitsIcons);
const getAutoDeliveryStatusInactiveBenefitsIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().autoDeliveryStatusInactiveBenefitsIcons);
const getAutoDeliveryStatusInactiveHowItWorksIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().autoDeliveryStatusInactiveHowItWorksIcons);
const getAutoDeliveryStatusNoneBenefitsIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().autoDeliveryStatusNoneBenefitsIcons);
const getAutoDeliveryStatusNoneHowItWorksIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().autoDeliveryStatusNoneHowItWorksIcons);

const getGetStartedPage = () => getPagesConfig().getStarted;
const getDynamicPages = () => getPagesConfig().dynamicPages;

const getLogoImageMedia = () => getMediaConfig().logoImageMedia;
const getLeviaLearnMorePopupHeaderIcon = () => getMediaConfig().leviaLearnMorePopupHeaderIcon;
const getLeviaLearnMorePopupIcons = () => arrayUtils.sortArrayWithOrderField(getMediaConfig().leviaLearnMorePopupIcons);

const getFirmwareAvailablePopupHeaderIcon = () => getMediaConfig().firmwareAvailablePopupHeaderIcon;
const getDevicesInfoIcon = () => getMediaConfig().devicesInfoIcon;

const getMaintenancePopupIcon = () => getMediaConfig().maintenancePopupIcon;

const getYourDevicesPromotionList = () => getConfig().yourDevicesPromotionList || [];

const getSetUpYourIqosImageMedia = () => getMediaConfig().setUpYourIqosImageMedia;
const getQuickOrderBenefitsIcons = () => arrayUtils.sortArrayWithOrderField(getMediaConfig().quickOrderBenefitsIcons);
const getQuickOrderHowItWorksIcons = () =>
    arrayUtils.sortArrayWithOrderField(getMediaConfig().quickOrderHowItWorksIcons);

const getIsGetStartedLanguageSelectEnabled = () => getPagesConfig().isGetStartedLanguageSelectEnabled;

const getBleConnectionFlowSettings = () => getConfig().bleConnectionFlowSettings;
const getUsbConnectionFlowSettings = () => getConfig().usbConnectionFlowSettings;
const getConnectionAvailabilityList = () => getConfig().connectionAvailabilityList || [];

const getFirmwareUpdateAvailabilityList = () => getConfig().firmwareUpdateAvailabilityList || [];

const getIccRegistrationSettings = () => getConfig().iccRegistrationSettings || {};
const getIccUnregistrationType = () => getIccRegistrationSettings().unregistrationType;

export default {
    getDeviceSupport,
    getDeviceSettings,
    getIsWarningIconEnabled,

    getIsRestrictedMarket,
    getIsLoyaltyEnabled,
    getIsDcxLoyaltyEnabled,
    getIsLoyaltyApiEnabled,
    getIsLoyaltyProgressBarEnabled,
    getLoyaltyLevels,
    getIsLoyaltyButtonsBarEnabled,
    getLoyaltyButtonsBar,
    getLoyaltyBadgeSsoUrl,
    getLoyaltyFinishWhatYouStartedSsoUrl,
    getHomePageForYouSection,
    getHomePageAutoDeliveryBanner,
    getWarningBanners,
    getAdConfig,
    getContactUs,
    getEnableNotificationPageHeaderImageMedia,
    getEnableNotificationPageHeaderVideoSrc,
    getEnableNotificationPageHeaderVideoThumbnailSrc,
    getEnableNotificationPageIcons,

    getTopBanners,

    getYourUsualBanners,

    getAutoDeliveryDashboardInactiveBenefitsIcons,
    getAutoDeliveryStatusInactiveBenefitsIcons,
    getAutoDeliveryStatusInactiveHowItWorksIcons,
    getAutoDeliveryStatusNoneBenefitsIcons,
    getAutoDeliveryStatusNoneHowItWorksIcons,
    getAutoDeliveryDetailedBannerNone,
    getAutoDeliveryDetailedBannerInactive,

    getGetStartedPage,
    getDynamicPages,

    getLogoImageMedia,
    getHighlights,
    getHighlightsDesktop,
    getHighlightsAutoplay,
    getHighlightsDesktopAutoplay,
    getMaintenancePopupIcon,
    getLeviaLearnMorePopupHeaderIcon,
    getLeviaLearnMorePopupIcons,
    getFirmwareAvailablePopupHeaderIcon,
    getYourDevicesPromotionList,
    getShopByProductSection,
    getClubPlusSection,
    getSetUpYourIqosImageMedia,
    getDevicesInfoIcon,

    getQuickOrderBanner,
    getQuickOrderBenefitsIcons,
    getQuickOrderHowItWorksIcons,

    getIsGetStartedLanguageSelectEnabled,
    getBleConnectionFlowSettings,
    getUsbConnectionFlowSettings,
    getConnectionAvailabilityList,

    getFirmwareUpdateAvailabilityList,

    getIccUnregistrationType,
};
